import { TdProps } from 'app/common/ui-components/table'

import { Entity } from './types'

const SATURDAY_ROW_BG_COLOR = 'rgb(255, 220, 217)' as const

const defaultCellsProps = {
  [Entity.Date]: { alignCenter: true, width: 140 },
  [Entity.CountRow]: { alignRight: true, minWidth: 90, borderRight: true },
  [Entity.SumRow]: { alignRight: true, minWidth: 110 },
}

export const createDataProps = () => {
  return new Proxy(defaultCellsProps, {
    get: function (target, property) {
      const key = property as string
      const res = target[key]

      if (res) {
        return res
      }

      if (key.endsWith('_count')) {
        return { alignRight: true, minWidth: 90, borderRight: true, }
      }

      if (key.endsWith('_sum')) {
        return { alignRight: true, minWidth: 110, borderRight: true, ignoreLastChild: true, }
      }

      return {}
    },
  })
}

const totalCellsProps = {
  [Entity.Date]: { alignRight: true, width: 140, bold: true },
  [Entity.CountRow]: { alignRight: true, highlighted: true, bold: true, borderRight: true, minWidth: 90 },
  [Entity.SumRow]: { alignRight: true, highlighted: true, bold: true, minWidth: 110 },
}

export const createTotalProps = () => {
  return new Proxy(totalCellsProps, {
    get: function (target, property) {
      const key = property as string
      const res = target[key]

      if (res) {
        return res
      }

      if (key.endsWith('_count')) {
        return {
          alignRight: true,
          highlighted: true,
          bold: true,
          minWidth: 90,
          borderRight: true,
        }
      }

      if (key.endsWith('_sum')) {
        return {
          alignRight: true,
          highlighted: true,
          bold: true,
          minWidth: 110,
          borderRight: true,
        }
      }

      return { highlighted: true, bold: true }
    },
  })
}

export const createTdPropsByRowAndColumnKey = (saturdayRowKeys: Set<string>) => {
  return ({
    rowKey,
  }: {
    side: 'left' | 'right' | 'main'
    rowKey: string
    columnKey: string
  }) => {
    const props = {} as Omit<TdProps, 'children' | 'className'>

    if (saturdayRowKeys.has(rowKey)) {
      props.bgColor = SATURDAY_ROW_BG_COLOR
    }

    return props
  }
}
